import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../../../components/library/loaders/Skeleton';
import './ClientNameHeader.scss'

const ClientNameHeader = (props) => {

    const [name, setName] = useState(null)

    useEffect(() => {
        if (!props.client || (!props.client.firstName && !props.client.lastName)) {
            setName(null)
        } else {
            setName((props.client.firstName ? (props.client.firstName + ' ') : '') + (props.client.lastName || ''))
        }
    }, [props.client]);

    return (
        <div className='columns'>
            <div className='column is-1' />
            <div className='column is-10' >
                <div id='client-info-name-header'>
                    <h1>
                        {name &&
                            <span id='client-name-header-name'>{name}</span>
                        }
                        {!name && 
                            <Skeleton />
                        }
                    </h1>
                    <hr />
                </div>
            </div>
            <div className='column is-1' />
        </div>
    );
}

ClientNameHeader.propTypes = {
    client: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
    })
}

export default ClientNameHeader